// import FacebookIcon from "@mui/icons-material/Facebook";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import { Link } from "react-router-dom";

// export default function Footer() {
//   return (
//     <footer className="footer-section-wrapper bg-white print:hidden">
//       <div className="container-x block mx-auto pt-[56px]">
//         <div className="lg:flex border-t border-qgray-border pt-8 justify-between mb-[50px]">
//           <div className="lg:w-[424px]  ml-0 w-full mb-10 lg:mb-0">
//             <Link to="/about">
//               <h1 className="text-[18] font-500 text-[#2F2F2F] mb-5">About Us</h1>
//             </Link>
//             <p className="text-[#9A9A9A] text-[15px] w-[247px] leading-[28px]">
//                 Blah, blah, blah.
//             </p>
//           </div>
//           <div className="flex-1 lg:flex">
//             <div className="lg:w-1/2 lg:flex lg:flex-col items-center w-full mb-10 lg:mb-0">
//               <div>
//                 <div className="mb-5">
//                   <h6 className="text-[18] font-500 text-[#2F2F2F]">Alpha</h6>
//                 </div>
//                 <div>
//                   <ul className="flex flex-col space-y-4 ">
//                     <li>
//                       <Link to="/event">
//                         <span className="text-[#9A9A9A] text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
//                           One
//                         </span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/conversation">
//                         <span className="text-[#9A9A9A] text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
//                           Two
//                         </span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/about">
//                         <span className="text-[#9A9A9A] text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
//                           Three
//                         </span>
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//             <div className="lg:w-1/2 w-full mb-10 lg:mb-0">
//               <div className="mb-5">
//                 <h6 className="text-[18] font-500 text-[#2F2F2F]">Beta</h6>
//               </div>
//               <div>
//                 <ul className="flex flex-col space-y-4 ">
//                   <li>
//                     <Link to="/faq">
//                       <span className="text-[#9A9A9A] text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
//                         FAQ
//                       </span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/terms">
//                       <span className="text-[#9A9A9A] text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
//                         Terms and Conditions
//                       </span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/privacy">
//                       <span className="text-[#9A9A9A] text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
//                         Privacy Policy
//                       </span>
//                     </Link>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="bottom-bar border-t border-qgray-border lg:h-[82px] lg:flex justify-between items-center">
//           <div className="flex lg:space-x-5 justify-between items-center mb-3">
//             <div className="flex space-x-5 items-center">
//               <a href="http://www.facebook.com" target="new">
//                 <FacebookIcon sx={{ color: "#797979" }} />
//               </a>
//               <a href="http://www.youtube.com" target="new">
//                 <YouTubeIcon sx={{ color: "#797979" }} />
//               </a>
//             </div>
//             <span className="sm:text-base text-[10px] text-qgray font-300">
//               &copy; 2024 Unchurch. All rights reserved.
//             </span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        backgroundColor: "secondary.main",
      }}
    >
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center">
          <Grid item xs={12}>
            <Typography color="black" variant="h5">
              {"© Dhorobha"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography color="textSecondary" variant="subtitle1">
              {`${new Date().getFullYear()} | React | Material UI | React Router`}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
